import Vue from 'vue';
import { Message,Notification  } from 'element-ui';
import axios from 'axios';
import Qs from 'qs'
import router from '../router/index.js'
import store from '../store'
let Host = '';
let routerMode = 'hash';
import VueI18n from 'vue-i18n';
//let imgBaseUrl;
if(process.env.NODE_ENV == 'development') {
    axios.defaults.baseURL = '/api/'

} else if(process.env.NODE_ENV == 'production') {
    axios.defaults.baseURL = '/'
}
axios.interceptors.request.use(function(config) {
  //在发送请求之前做一些事情
  let language = window.localStorage.getItem("language");
  config.headers.ResponseLang = language ? language : 'zh-cn';

  let token = window.localStorage.getItem("utoken");
  if (token) {
    config.headers.Authorization = token;
  } else {}
  return config;
}, function(error) {
  // 请求错误做一些事情
  return Promise.reject(error);
});
let _this = this

axios.interceptors.response.use(function(response) {
  //对响应数据做一些处理
  return response;
}, function(error) {
  // 对响应失败做一些处理
  if (error && error.response && error.response.status) {
    switch (error.response.status) {
      case 401:
      case 403:
        // 判断是否已存在Message
        if (document.getElementsByClassName('el-message').length === 0) {
          Message({message: error.response.data.message,duration:1500, type: 'error', onClose:function(){
              localStorage.removeItem('utoken');
              //辣鸡报错  localStorage 全清了 over
              localStorage.clear()
              store.commit('setUserName', null);
              store.commit('setAdmin_url', null);
              store.commit('setHeadimgurl', null);
              store.commit('setUtoken', null);
              if(router.currentRoute.name != 'login'){
                store.commit('setDialogLogin',true);
              }
             
              // router.replace({
              //   path: '/Login',
              //   query: {
              //     redirect: router.currentRoute.fullPath
              //   }
              // });
            }
          });
        }
        break;
      case 502:
        // 判断是否已存在Message
        if (document.getElementsByClassName('el-message').length === 0) {
          Message({message: error.response.data.message, type: 'error',duration:1500, onClose:function(){
              if(localStorage.getItem("utype")){
                router.replace({path: '/',});
              }else{
                router.replace({path: '/login',});
              }
            }
          });
        }
        break;
      case 500:
        let i18n = new VueI18n({
          locale: window.localStorage.getItem("language") ? window.localStorage.getItem("language") : 'zh-cn',
          messages: {'zh-cn': require('@/assets/languages/zh-cn.json'), 'zh-hk': require('@/assets/languages/zh-hk.json'), 'en': require('@/assets/languages/en.json')}
        });
        if (document.getElementsByClassName('el-message').length === 0) {
          Notification({   title: i18n.t("Error reminder"),message: i18n.t('http code 500'),  position: 'bottom-right',type: 'error',duration:1500});
        }
        break;
      default:
        break;
    }
  }
  return Promise.reject(error);
});

//get封装
export function getAjax(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params,
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}
//post封装
export function postAjax(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, Qs.stringify(data), {
          headers: {
              'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/x-www-form-urlencoded',
          }
        })
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js